<template>
    <div class="main">
        <c-panel title="ALMOXARIFADO — REQUISIÇÕES" titleIcon="fas fa-file-signature">
            <el-form label-position="top">
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="5" v-if="ehSmed">
                        <el-form-item label="Instituição">
                            <el-select v-model="filtro.instituicao_id" placeholder="Todas" filterable clearable style="width:100%;" @change="load(1)">
                                <el-option v-for="i in $store.state.instituicoes" :key="i.id" :label="i.nome" :value="i.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="4">
                        <el-form-item label="Sentido">
                            <el-select v-model="filtro.sentido" placeholder="Todos" clearable style="width:100%;" @change="load(1)">
                                <el-option label="Entrada" value="entrada"></el-option>
                                <el-option label="Saída" value="saida"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="4">
                        <el-form-item label="Status">
                            <el-select v-model="filtro.status" placeholder="Todos" clearable style="width:100%;" @change="load(1)">
                                <el-option label="Aberta" :value="1"></el-option>
                                <el-option label="Efetivada" :value="2"></el-option>
                                <el-option label="Cancelada" :value="3"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="6">
                        <el-form-item label="Período (data)">
                            <el-date-picker v-model="periodo" type="daterange" value-format="yyyy-MM-dd" format="dd/MM/yyyy" range-separator="até" start-placeholder="Início" end-placeholder="Fim" style="width:100%;" @change="onPeriodo"></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="5" class="u-text-right" style="padding-top: 30px;">
                        <el-button type="info" plain icon="el-icon-printer" @click="imprimirRelatorio">RELATÓRIO</el-button>
                        <router-link to="/admin/almox-requisicao/cadastro" class="btn-new-register u-ml-10">
                            <el-button type="primary">NOVA REQUISIÇÃO</el-button>
                        </router-link>
                    </el-col>
                </el-row>
            </el-form>

            <div class="container-table">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th style="width: 150px;">Número</th>
                            <th style="width: 80px;">Sentido</th>
                            <th style="width: 90px;">Data</th>
                            <th class="hidden-mobile">Instituição</th>
                            <th class="hidden-mobile u-text-center" style="width: 70px;">Itens</th>
                            <th style="width: 100px;" class="u-text-center">Status</th>
                            <th style="width: 200px;" class="u-text-center">Ação</th>
                        </tr>
                    </thead>
                    <tbody v-if="statusList">
                        <tr v-for="r in items" :key="r.id">
                            <td>{{ r.numero }}</td>
                            <td><el-tag size="mini" :type="r.sentido === 'entrada' ? 'success' : 'warning'">{{ r.sentido === 'entrada' ? 'Entrada' : 'Saída' }}</el-tag></td>
                            <td>{{ r.data_requisicao | formatarData }}</td>
                            <td class="hidden-mobile">{{ r.instituicao ? r.instituicao.nome : '—' }}</td>
                            <td class="hidden-mobile u-text-center">{{ r.itens ? r.itens.length : 0 }}</td>
                            <td class="u-text-center"><el-tag size="mini" :type="tagStatus(r.status)">{{ rotuloStatus(r.status) }}</el-tag></td>
                            <td class="u-text-center acao">
                                <router-link :to="'/admin/almox-requisicao/edit/' + r.id" class="link-icon u-mr-5" style="color: rgba(0, 0, 0, 0.87) !important;">
                                    <el-button :type="r.status === 1 ? 'info' : 'primary'" :title="r.status === 1 ? 'Editar' : 'Visualizar'" :icon="r.status === 1 ? 'el-icon-edit' : 'el-icon-view'" size="mini" plain></el-button>
                                </router-link>
                                <el-button v-if="r.status === 1" @click="efetivar(r)" title="Efetivar (gera movimentos)" type="success" icon="el-icon-finished" size="mini" plain class="u-mr-5"></el-button>
                                <el-button v-if="r.status === 1" @click="cancelar(r)" title="Cancelar" type="warning" icon="el-icon-close" size="mini" plain class="u-mr-5"></el-button>
                                <el-button v-if="r.status !== 2" @click="excluir(r)" title="Excluir" type="danger" icon="el-icon-delete" size="mini" plain></el-button>
                            </td>
                        </tr>
                        <tr v-if="!items.length"><td colspan="7" class="u-text-center" style="padding: 20px; color: #909399;">Nenhuma requisição encontrada.</td></tr>
                    </tbody>
                </table>

                <div v-if="!statusList" class="u-text-center u-mt-25"><img src="/public/img/loading-bar.gif" /></div>

                <el-row :gutter="10" v-if="statusList">
                    <el-col :xs="24" :sm="12"><div class="u-text-left u-mt-10">Mostrando {{ paginate.from }} até {{ paginate.to }} de {{ paginate.qtdItens }} registros.</div></el-col>
                    <el-col :xs="24" :sm="12" v-if="paginate.qtdItens > 30">
                        <div class="u-text-right">
                            <el-pagination :current-page="paginate.page" class="u-mt-10" :total="paginate.qtdItens" @current-change="load" :page-size="30" background layout="prev, pager, next" small></el-pagination>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </c-panel>
    </div>
</template>

<script>
import moment from 'moment'
export default {
    filters: { formatarData (v) { return v ? moment(v).format('DD/MM/YYYY') : '' } },
    data: () => ({
        statusList: false,
        periodo: [],
        filtro: { instituicao_id: '', sentido: '', status: '', data_inicio: '', data_fim: '' },
        paginate: { page: 1, qtdItens: null, from: '', to: '' },
        items: []
    }),
    computed: {
        ehSmed () { return [4, 5, 6, 7, 8, 10].includes(Number(this.$store.state.user.tipo)) }
    },
    mounted () {
        if (!this.ehSmed && this.$store.state.config.instituicao) {
            this.filtro.instituicao_id = this.$store.state.config.instituicao.id
        }
        this.load(1)
    },
    methods: {
        baseUrl () { return this.$store.state.config.baseUrlApi },
        rotuloStatus (s) { return { 1: 'Aberta', 2: 'Efetivada', 3: 'Cancelada' }[s] || '?' },
        tagStatus (s) { return { 1: 'info', 2: 'success', 3: 'danger' }[s] || '' },
        onPeriodo () {
            this.filtro.data_inicio = (this.periodo && this.periodo[0]) || ''
            this.filtro.data_fim = (this.periodo && this.periodo[1]) || ''
            this.load(1)
        },
        load (page) {
            this.paginate.page = page || 1
            this.statusList = false
            this.items = []
            this.$axios.post(`${this.baseUrl()}/api/almox-requisicao/getAllPaginate?page=${this.paginate.page}`, this.filtro, this.$store.getters.getHeaderAuth)
                .then(r => {
                    this.items = r.data.data
                    this.paginate.qtdItens = r.data.total
                    this.paginate.from = r.data.from
                    this.paginate.to = r.data.to
                    this.statusList = true
                }).catch(e => { this.statusList = true; this.$store.commit('throwException', e) })
        },
        efetivar (r) {
            this.$msgbox.confirm(`Efetivar a requisição ${r.numero}? Isso gera os movimentos de estoque e não pode ser desfeito.`, 'Atenção', { confirmButtonText: 'Efetivar', cancelButtonText: 'Não', type: 'warning' }).then(() => {
                window.eventBus.$emit('loading', true)
                this.$axios.post(`${this.baseUrl()}/api/almox-requisicao/efetivar/${r.id}`, {}, this.$store.getters.getHeaderAuth).then(res => {
                    window.eventBus.$emit('loading', false)
                    if (res.data && res.data.erro) { window.eventBus.$emit('alert', { msg: res.data.erro, type: 'warning' }); return }
                    window.eventBus.$emit('alert', { msg: 'Requisição efetivada.', type: 'success' })
                    this.load(this.paginate.page)
                }).catch(e => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', e) })
            }).catch(() => {})
        },
        cancelar (r) {
            this.$msgbox.confirm(`Cancelar a requisição ${r.numero}?`, 'Atenção', { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' }).then(() => {
                this.$axios.post(`${this.baseUrl()}/api/almox-requisicao/cancelar/${r.id}`, {}, this.$store.getters.getHeaderAuth).then(res => {
                    if (res.data && res.data.erro) { window.eventBus.$emit('alert', { msg: res.data.erro, type: 'warning' }); return }
                    window.eventBus.$emit('alert', { msg: 'Requisição cancelada.', type: 'success' })
                    this.load(this.paginate.page)
                }).catch(e => this.$store.commit('throwException', e))
            }).catch(() => {})
        },
        excluir (r) {
            this.$msgbox.confirm(`Excluir a requisição ${r.numero}?`, 'Atenção', { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' }).then(() => {
                this.$axios.delete(`${this.baseUrl()}/api/almox-requisicao/delete/${r.id}`, this.$store.getters.getHeaderAuth).then(res => {
                    if (res.data && res.data.erro) { window.eventBus.$emit('alert', { msg: res.data.erro, type: 'warning' }); return }
                    window.eventBus.$emit('alert', { msg: 'Excluído com sucesso.', type: 'success' })
                    this.load(this.paginate.page)
                }).catch(e => this.$store.commit('throwException', e))
            }).catch(() => {})
        },
        imprimirRelatorio () {
            window.eventBus.$emit('print', { url: '/api/almox-requisicao/relatorio', param: this.filtro })
        }
    }
}
</script>
